// extracted by mini-css-extract-plugin
export var card = "product-slider-module--card--YjIqQ";
export var cardBox = "product-slider-module--card-box--7Scoa";
export var container = "product-slider-module--container--3dj0t";
export var header = "product-slider-module--header--ACp80";
export var slider = "product-slider-module--slider--lj4ND";
export var sliderContainer = "product-slider-module--slider-container--2xOS9";